module.exports = __webpack_public_path__ + "static/img/img_awards_7.9587747.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aboutUs/img_awards_7.png
// module id = SLLF
// module chunks = 15